exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#entryEmbedCode,\n#jobEmbedCode {\n  border: 1px solid #ced4da !important;\n}\n.error-message {\n  color: red;\n  font-size: 15px;\n}\n.setting_white_space_break {\n  white-space: break-spaces;\n}\n", ""]);

// exports
